import {UUID} from '../../../shared/types/uuid.type';
import { createAction, props } from '@ngrx/store';

const prefix = '[DeleteManyDestinations] ';

export const deleteManyDestinations = createAction(
  `${prefix} Delete Many Destinations`,
  props<{ ids: UUID[] }>()
);

export const deleteManyDestinationsSuccess = createAction(
  `${prefix} Delete Many Destinations Success`,
  props<{ ids: UUID[] }>()
);

export const deleteManyDestinationsFailure = createAction(
  `${prefix} Delete Many Destinations Failure`,
  props<{ error: any }>()
);

export const clearDeleteManyDestinationsState = createAction(
  `${prefix} Clear Delete Many Destinations State`,
);
